import AwesomeDebouncePromise from 'awesome-debounce-promise';
import React, { Component } from 'react';
import TypeAheadComponent from './TypeAheadComponent';

const SUGGEST_DEBOUNCE_MS = 400;

export default class AddressPicker extends Component {
    addressSuggestionsCache = []

    getSuggestions = AwesomeDebouncePromise(async (query) => {
         if (query && query.length >= 3) {
         const
             url = new URL('/geocoding', window.location.href),
             params = {
                 geocode: query,
                 // bbox: "62.0537597515,66.4152456047~56.0053847967,56.9835553191",
                 // rspn: 1,
             };
         Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))

         let resp = await fetch(url)
          console.log(resp);

         if(resp.status === 429) {
            console.warn('geocoding rate limit exceeded');
            return [];
         }
         let data = await resp.json();

         console.log(data);

        const cache = data.response.GeoObjectCollection.featureMember.map(
            feature => {return {
                  label: feature.GeoObject.metaDataProperty.GeocoderMetaData.text.replace(
                      'Россия, Свердловская область, ',
                     ''
                   ),
                   address: feature.GeoObject.metaDataProperty.GeocoderMetaData.text,
                   point: feature.GeoObject.Point.pos.split(' ').map(s => parseFloat(s))
            }}
        )
        this.addressSuggestionsCache.push(...cache)
            return cache
        } else {
            return [];
        }
    }, SUGGEST_DEBOUNCE_MS);

    render() {
        const {onSelect, defaultValue} = this.props
        return (
        <TypeAheadComponent
            defaultValue={defaultValue}
            getSuggestions={this.getSuggestions}
            parentSearchChangeHandler={(v) => {
               const {addressSuggestionsCache} = this;
               const candidate = addressSuggestionsCache.filter(cacheEl => cacheEl.label == v)[0];
               onSelect(candidate || { address: v });
               this.addressSuggestionsCache = [];
            }}
            parentOnChangeHandler={(v) => {
                const {addressSuggestionsCache} = this;
                const candidate = addressSuggestionsCache.filter(cacheEl => cacheEl.label == v)[0];
                onSelect(candidate || { address: v });
                this.addressSuggestionsCache = [];
            }}
        />
        )
    }
}



// WEBPACK FOOTER //
// ./src/AddressPickerComponent.js